import { Box, Grid, Typography, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	root: {
		padding: '12px',
		borderRadius: '8px',
		background: '#E8FBF6',
	},
	title: {
		fontSize: '14px',
		fontWeight: 500,
		color: '#18CFA3',
	},
	hr: {
		border: '1px solid ',
		borderColor: '#18CFA3',
		margin: '12px 0',
		opacity: '0.3',
	},
	titlePrice: {
		display: 'flex',
		alignItems: 'center',
		fontSize: '12px',
		fontWeight: 500,
		color: '#14AC88',
	},
	unitPrice: {
		marginLeft: '4px',
		fontSize: '18px',
		fontWeight: 700,
		color: '#14AC88',
	},
}));

const InvoiceType = ({ falid }) => {
	const classes = useStyles();

	return (
		<Grid container className={classes.root} {...(falid && { style: { background: '#E6F3FF' } })}>
			<Grid item xs={12}>
				<Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Grid item xs={5}>
						<Typography className={classes.title} {...(falid && { style: { color: '#0184FD' } })}>
							شیوه پرداخت:
						</Typography>
					</Grid>
					<Grid item xs={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Typography className={classes.title} {...(falid && { style: { color: '#0184FD' } })}>
							آنلاین{' '}
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid item xs={12}>
				<Box {...(falid && { style: { borderColor: '#0184FD' } })} className={classes.hr} />
			</Grid>
			<Grid item xs={12}>
				<Grid container style={{ display: 'flex', justifyContent: 'space-between' }}>
					<Grid item xs={5}>
						<Typography className={classes.title} {...(falid && { style: { color: '#0184FD' } })}>
							مجموع مبلغ پرداخت شده:
						</Typography>
					</Grid>
					<Grid item xs={5} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<Typography className={classes.titlePrice} {...(falid && { style: { color: '#0184FD' } })}>
							<Typography className={classes.unitPrice} {...(falid && { style: { color: '#0184FD' } })}>
								8,625,000
							</Typography>
							تومان
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default InvoiceType;
